import getWithToken from './base/get-with-token'

const getPermissions = getWithToken('/permission')

export default getPermissions